//! this is url for deployment on Netlify
const Url = "/api/"

//! this is url when testing on localhost with nginx listening on localhost:80
//const Url = "http://localhost/"

export default Url